package com.devi3east.bashbuddy.features.common.util

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import kotlinx.datetime.*

@Composable
fun DateInput(
    dateInstant: Instant?,
    label: String = "Date",
    showPicker: Boolean = false,
    onDateChange: (Instant) -> Unit
) {
    val cardShape = RoundedCornerShape(12.dp)
    var showDatePicker by remember { mutableStateOf(showPicker) }

    val displayDate = remember(dateInstant) {
        DateTimeFormatUtil.instantToDateString(dateInstant)
    }

    LaunchedEffect(showPicker) {
        showDatePicker = showPicker
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .clip(cardShape)
            .clickable { showDatePicker = true }
    ) {
        OutlinedTextField(
            value = displayDate,
            onValueChange = {},
            label = {
                Text(
                    text = label,
                    style = LocalTextStyle.current.copy(
                        color = if (displayDate.isNotBlank())
                            MaterialTheme.colorScheme.onSurface
                        else
                            MaterialTheme.colorScheme.onSurfaceVariant
                    )
                )
            },
            readOnly = true,
            enabled = false,
            singleLine = true,
            modifier = Modifier.fillMaxWidth(),
            shape = cardShape,
            colors = OutlinedTextFieldDefaults.colors(
                focusedTextColor = MaterialTheme.colorScheme.onSurface,
                unfocusedTextColor = MaterialTheme.colorScheme.onSurfaceVariant,
                disabledTextColor = MaterialTheme.colorScheme.onSurface,
                focusedBorderColor = MaterialTheme.colorScheme.primary,
                unfocusedBorderColor = MaterialTheme.colorScheme.outline,
                disabledBorderColor = MaterialTheme.colorScheme.outline,
                cursorColor = MaterialTheme.colorScheme.primary
            ),
            visualTransformation = VisualTransformation.None
        )
    }

    if (showDatePicker) {
        ModernCalendarPicker(
            initialInstant = dateInstant,
            onDateSelected = {
                onDateChange(it)
                showDatePicker = false
            },
            onDismiss = { showDatePicker = false }
        )
    }
}